const phaseTimings: Record<string, number> = {};

export function getAppShellPhaseTimings() {
  return phaseTimings;
}

export function markAppShellPhase(name: string, time = performance.now()) {
  phaseTimings[name] = time;
}
